import template from './contactsDelete.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
controller: class controller {
    constructor($mdDialog, $mdMedia, $timeout, eventService, contactsService, uiService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = function () {
        ctrl.destroyWatch = eventService.onContactDeleted(function (_params) {
          $mdDialog
            .show({
              targetEvent: _params.event,
              locals: {
                selectedContacts: _params.selectedContacts,
                organizationName: _params.organizationName
              },
              template,
              controllerAs: '$ctrl',
              controller: dialogController
            })
            .then(function (deletedContacts) {
              var idDeletedContacts = [];
              var len = deletedContacts.length;
              while (len--) {
                ctrl.onFinished({ contact: deletedContacts[len] });
                idDeletedContacts.push(deletedContacts[len].id);
              }

              contactsService.deleteContacts(idDeletedContacts).then(function (data) {
                if (data.status) {
                  uiService.toast({
                    text: {
                      p1: idDeletedContacts.length,
                      p2: 'Contacts(s)',
                      p3: 'have been deleted'
                    }
                  });
                }
              });
            });

          function dialogController(scope, $mdDialog, selectedContacts, organizationName) {
            this.selectedContacts = selectedContacts;
            this.organizationName = '';
            this.isOrganizationNameEqual = function () {
              return this.organizationName.toLowerCase() === organizationName.toLowerCase();
            };

            this.confirm = function () {
              $mdDialog.hide(this.selectedContacts);
            };
            this.cancel = function () {
              $mdDialog.cancel();
            };
          }
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = function (changes) {};

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      this.$onDestroy = function () {
        ctrl.destroyWatch();
      };
    }
  }
};
